var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 3.83301H3.33366C2.41318 3.83301 1.66699 4.5792 1.66699 5.49967V15.4997C1.66699 16.4201 2.41318 17.1663 3.33366 17.1663H16.667C17.5875 17.1663 18.3337 16.4201 18.3337 15.4997V5.49967C18.3337 4.5792 17.5875 3.83301 16.667 3.83301Z",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 6.33301L10.8587 11.083C10.6014 11.2442 10.3039 11.3297 10.0003 11.3297C9.69673 11.3297 9.39927 11.2442 9.14199 11.083L1.66699 6.33301",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f665a1906b5bc86e8a95531cd4a6f2b6.svg";
export { ForwardRef as ReactComponent };